const Signup_Api_Path = '/signup';
const Login_Api = '/login';
const Home_Api='/home';
const Shop_Api='/shop'
const Special_Categ ='/SplCategories';
const Check_Pincode='/servicable';
const Cart='/cart';
const Add_Cart='/add-to-cart';
const Delete_Cart='/delete-cart';
const Update_Quantity='/update-quantity';
const Weight_loss='/meal-plans/diets/weight-loss';
const Weight_Gain='/meal-plans/diets/weight-gain';
const Pcod='/meal-plans/diets/pcod';
const Diabetes_Mellitus='/meal-plans/diseases/diabetes-mellitus'
const Thyroid='/meal-plans/diseases/thyroid'
// const Gluten_Free='/meal-plans/diets/gluten-free';
const Weaning='/meal-plans/ages/babies';
const School_Going='/meal-plans/ages/school-going';
const Adults='/meal-plans/ages/adults';
const Expectant_Mothers='/meal-plans/ages/expectant-mothers';
const Lactating_Mothers='/meal-plans/ages/lactating-mothers'
const Special_Categories='/products-by-category'
const Product_Details='/products';
const Send_Address='/address';
const Checkout='/checkout';
const Place_Order='/payment';
const Checkout_Data='/place-order';
const Create_Order='/create-order';
const Contact_Form='/contact';
const Send_Otp='/mobile-otp-verify';
const Resend_Otp='/sent-otp';
const Reset_Password='/forgot_password';
const New_Password='/forgot-password-reset-password';
const Send_Forgot_Otp='/forgot-password-otp-verify';
const Verify_Payment='/verify-payment';
const Order_History='/order_list'

export const API_URLS = {
  SIGNUP_API_PATH: `${Signup_Api_Path}`,
  LOGIN_API_PATH: `${Login_Api}`,
  HOME_API:`${Home_Api}`,
  SHOP_API:`${Shop_Api}`,
  SPECIAL_CATEG:`${Special_Categ}`,
  CHECK_PINCODE:`${Check_Pincode}`,
  CART:`${Cart}`,
  ADDCART:`${Add_Cart}`,
  DELETE_CART:`${Delete_Cart}`,
  UPDATE_QUANTITY:`${Update_Quantity}`,
  WEIGHT_LOSS:`${Weight_loss}`,
  WEIGHT_GAIN:`${Weight_Gain}`,
  PCOD:`${Pcod}`,
  DIABETES:`${Diabetes_Mellitus}`,
  GLUTEN_FREE:`${Thyroid}`,
  WEANING:`${Weaning}`,
  SCHOOL_GOING:`${School_Going}`,
  ADULTS:`${Adults}`,
  EXPECTANT_MOTHERS:`${Expectant_Mothers}`,
  LACTATING_MOTHERS:`${Lactating_Mothers}`,
  SPECIAL_CATEGORIES:`${Special_Categories}`,
  PRODUCT_DETAILS:`${Product_Details}`,
  SUBMIT_ADDRESS:`${Send_Address}`,
  CHECKOUT:`${Checkout}`,
  PLACE_ORDER:`${Place_Order}`,
  CHECKOUT_DATA:`${Checkout_Data}`,
  CONTACT_FORM_API_PATH:`${Contact_Form}`,
  OTP_PAGE:`${Send_Otp}`,
  RESEND_OTP:`${Resend_Otp}`,
  RESET_PASSWORD:`${Reset_Password}`,
  NEW_PASSWORD:`${New_Password}`,
  SEND_FORGOT_OTP:`${Send_Forgot_Otp}`,
  CREATE_ORDER:`${Create_Order}`,
  VERIFY_PAYMENT:`${Verify_Payment}`,
  ORDER_HISTORY:`${Order_History}`,
};
